import { buildLinearGradientCssString } from './build-gradient-css-string';

export function buildFlatGradientFromColorStops(colorStops) {
  return buildLinearGradientCssString(90, colorStops);
}
